import { render, staticRenderFns } from "./contact-detail.vue?vue&type=template&id=03adabd2&scoped=true"
import script from "./contact-detail.vue?vue&type=script&lang=js"
export * from "./contact-detail.vue?vue&type=script&lang=js"
import style0 from "./contact-detail.vue?vue&type=style&index=0&id=03adabd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03adabd2",
  null
  
)

export default component.exports